import { ASSETS } from "@/lib/assets";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-[#141414] py-24 md:py-32 lg:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-12 gap-8 md:gap-12 lg:gap-20 items-start">
        {/* Image column */}
        <div className="col-span-12 lg:col-span-5 reveal">
          <div className="relative">
            <div className="absolute -inset-3 border border-[#C9A66B]/40 hidden md:block" />
            <div className="zoom-frame relative">
              <img
                src={ASSETS.founderHeadshot}
                alt="Founder of Becoming H.E.R. LLC"
                data-testid="founder-image"
                className="w-full h-auto block"
                loading="lazy"
              />
            </div>
            <div className="mt-5 flex items-center justify-between text-[10px] tracking-[0.28em] uppercase text-[#A0A0A0]">
              <span>Toyee Tinsley</span>
              <span className="font-serif italic text-sm text-[#EDEDED] normal-case tracking-normal">
                — Founder &amp; Principal
              </span>
            </div>
          </div>
        </div>

        {/* Copy column */}
        <div className="col-span-12 lg:col-span-7 reveal">
          <div className="text-[11px] tracking-[0.32em] uppercase text-[#C9A66B] mb-4">
            §  Meet the Founder
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-[#EDEDED]">
            <em>Toyee</em> Tinsley
          </h2>
          <p className="mt-3 font-serif italic text-lg md:text-xl text-[#A0A0A0]">
            Founder &amp; Principal, Becoming H.E.R. LLC
          </p>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10">
            <p className="md:col-span-7 text-[15px] md:text-base leading-relaxed text-[#A0A0A0] font-light">
              Toyee Tinsley brings extensive leadership experience
              across federal, local government, corporate sectors, and business
              enterprise — serving as a contracting officer in business
              administration, logistics, procurement, contracting, and
              organizational development.
            </p>
            <p className="md:col-span-5 text-[15px] md:text-base leading-relaxed text-[#A0A0A0] font-light">
              She holds a Bachelor of Science in Business Management and has
              successfully led multimillion-dollar acquisition and contracting
              programs throughout her career — the foundation on which
              Becoming H.E.R. LLC was built.
            </p>
          </div>

          <figure className="mt-12 md:mt-16 border-l-2 border-[#6B6B6B] pl-6 md:pl-10 max-w-2xl">
            <blockquote className="font-serif text-2xl md:text-3xl lg:text-4xl italic font-light text-[#EDEDED] leading-[1.25]">
              “We don&apos;t sell deliverables. We build the foundations our clients
              stand on for the next decade.”
            </blockquote>
            <figcaption className="mt-4 text-[10px] tracking-[0.3em] uppercase text-[#A0A0A0]">
              — Toyee Tinsley, Founder &amp; Principal
            </figcaption>
          </figure>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 border-t border-[#EDEDED]/15">
            {[
              ["Federal", "Government contracting"],
              ["Corporate", "Enterprise sectors"],
              ["Procurement", "Acquisition programs"],
              ["B.S.", "Business Management"],
            ].map(([title, sub]) => (
              <div
                key={title}
                className="py-6 pr-4 border-r last:border-r-0 border-[#EDEDED]/15"
              >
                <div className="font-serif text-xl text-[#EDEDED]">{title}</div>
                <div className="text-[10px] tracking-[0.24em] uppercase text-[#A0A0A0] mt-1">
                  {sub}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
